<template>
  <div>
    <LiberarASO :parent="this" />
    <DownloadASO :parent="this" />
    <UploadASO :parent="this" />
    <LembreteAssinatura :parent="this" />

    <TableView registerName="Upload de ASO" registerIcon="fa fa-upload"
      registerTitle="Clique aqui para fazer o upload dos ASO e liberar posteriormente" :onSearch="getConsulta"
      :onFilter="getConsulta" :tableHead="tableHead" :tableData="tableData" :loadingTable="config.loading.table"
      :pagination="pagination" :onRegister="validarPermissao(553) ? onRegister : null" :filterBadge="filterBadge"
      :response="response" disableCheckAll>
      <div slot="table-button" v-if="validarPermissao(561)">
        <ed-button icon="fa fa-paper-plane" type="warning" value="Enviar ASO por Email" @click="onDownloadASO(null)" />
      </div>
      <div slot="search-detail">Busca por código da consulta, nome do funcionário ou empresa</div>
      <!--FILTRAR RESULTADO-->
      <div slot="table-filter-content">
        <ed-form :data="formFilter" :config="config" :itens="formItems">
          <div slot="form-footer"></div>
        </ed-form>
      </div>
    </TableView>
  </div>
</template>

<script>
import crypto from "crypto"
import TableView from "common/table";
import Rest from "common/rest";
import EdButton from "common/button";
import EdForm from "common/form";
import LiberarASO from "./_includes/liberar-aso";
import UploadASO from "./_includes/upload-aso";
import DownloadASO from "./_includes/download-aso";
import LembreteAssinatura from "./_includes/lembrete-assinatura";
import FormItems from "./_form/liberacao-filtro";
import './style.css';

function getCookieValue(prefix) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(prefix)) {
      // Extract the value part after "web" prefix
      const cookieValue = cookie.substring(cookie.indexOf('=') + 1);
      return cookieValue;
    }
  }
  return null;
}


export default {
  name: "empresa",
  components: { TableView, LiberarASO, UploadASO, EdButton, EdForm, DownloadASO, LembreteAssinatura },
  mixins: [Rest],
  watch: {
    "formFilter.id_empresa"() {
      this.config.disabled.id_funcionario = this.formFilter.id_empresa ? false : true;
      this.getFuncionario();
    },
  },
  data() {
    return {
      config: {
        tipo: [46, 53],
        click: {
          id_empresa: _.debounce(this.getEmpresa, 1000),
          id_fdt: _.debounce(this.getFDT, 1000),
          id_funcionario: _.debounce(this.getFuncionario, 1000),
        },
        loading: {
          id_empresa: false,
          id_fdt: false,
          id_funcionario: false,
          table: false,
        },
        disabled: {
          id_funcionario: true,
        },
        list: {
          id_empresa: [],
          id_fdt: [],
          id_funcionario: [],
        },
      },
      formData: {
        id: 0,
        nome: null,
        cbo: null,
        descricao: null,
      },
      formFilter: {
        id_funcao: null,
        id_empresa: null,
        id_arquivo_aso: 0,
        inativo: 0,
        id_fdt: null,
        id_funcionario: null,
        id_tipo_aso: [],
        id_tipo_status: [68, 69],
        created_at: [],
      },
      pagination: {},
      response: {},
      consulta: null,
      tableHead: [
        {
          key: "data",
          sortable: true,
          label: "Data Consulta",
        },
        {
          key: "consulta",
          sortable: true,
          show_tipo_aso: true,
          show_consulta_link: true,
          label: "Consulta",
        },
        {
          key: "credenciada",
          sortable: true,
          label: "Credenciada",
        },
        {
          key: "empresa",
          sortable: true,
          show_fdt: true,
          show_empresa_link: true,
          label: "Empresa",
        },
        {
          key: "funcionario",
          sortable: true,
          show_funcao: true,
          show_funcionario_link: true,
          label: "Funcionário",
        },
        {
          key: "status",
          sortable: true,
          label: "Status",
        },
      ],
      tableData: [],
      formItems: [],
      showFormFilter: false,
      showLiberacao: false,
      showUploadASO: false,
      showDownloadASO: false,
      showLembreteAssinatura: false,
      loadingDownloadASO: false,
      filterBadge: "0",
    };
  },
  beforeDestroy() {
    this.tableData = [];
  },
  created() { },

  mounted: function () {
    this.formItems = FormItems;

    this.getConsulta();
    this.getEmpresa();
  },

  methods: {
    onLiberarASO: function (data) {
      this.consulta = data;
      this.showLiberacao = !this.showLiberacao;
    },

    onDownloadASO: function (data) {
      this.showDownloadASO = !this.showDownloadASO;
      this.loadingDownloadASO = true;

      if (!data) {
        this.loadingDownloadASO = false;
        this.consulta = data;
        return;
      }

      var filter = {
        id_tipo_email: [197],
        //id_fdt : (data.fdt ? data.fdt.id : null)
      };

      this.get("/empresa/email/" + data.empresa.id, { filter: filter }).then((result) => {
        result = result[0];

        this.loadingDownloadASO = false;

        if (result.status == 200) {
          var emails = [];

          for (let i = 0; i < result.data.data.length; i++) {
            emails.push(result.data.data[i].email);
          }
          data.empresa.email = emails.join(";");
        }

        this.consulta = data;
      });
    },

    onRegister: function () {
      this.showUploadASO = !this.showUploadASO;
    },

    getEmpresa: function (_search) {
      this.config.loading.id_empresa = true;
      this.config.list.id_empresa = [];

      this.get("/empresa", { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_empresa = false;

        // validando
        if (result.status == 200) {
          this.config.list.id_empresa = result.data.data;
        }
      });
    },

    getFuncionario: function (_search) {
      this.config.loading.id_funcionario = true;
      this.config.list.id_funcionario = [];

      this.get("/empresa/funcionario/" + this.formFilter.id_empresa, { search: _search }).then((result) => {
        result = result[0];

        this.config.loading.id_funcionario = false;

        if (result.status == 200) {
          this.config.list.id_funcionario = result.data.data;
        }
      });
    },

    getFDT: function () {
      this.config.loading.id_fdt = true;
      this.config.list.id_fdt = [];

      this.get("pcmso/fdt/" + this.formFilter.id_empresa, { pagination: 100 }).then((result) => {
        result = result[0];

        this.config.loading.id_fdt = false;

        if (result.status == 200) {
          this.config.loading.id_fdt = result.data.data;
        }
      });
    },

    getConsulta: function (_search, _page, _pagination, _loading) {
      this.config.loading.table = true;
      this.response = {};

      if (this.formFilter.created_at.length != 2) {
        var hoje = this.toDate(null, true),
          ontem = this.toDate(this.addDate(-60, null, "D"), true),
          amanha = this.toDate(this.addDate(1, null, "D"), true);

        this.formFilter.created_at = [ontem, amanha];
      }

      this.filterBadge = (this.formFilter.id_funcao ? 1 : 0) + (this.formFilter.id_funcionario ? 1 : 0) + (this.formFilter.id_empresa ? 1 : 0) + (this.formFilter.id_fdt ? 1 : 0) + (this.formFilter.created_at.length > 0 ? 1 : 0) + this.formFilter.id_tipo_aso.length + this.formFilter.id_tipo_status.length;

      this.get("empresa/consulta", { search: _search, page: _page, pagination: _pagination, filter: this.formFilter }).then((result) => {
        result = result[0];
        this.response = result;
        this.config.loading.table = false;

        if (result.status == 200) {
          var data = result.data.data,
            tableData = [],
            self = this,
            pagination = result.data;

          for (var i = 0; i < data.length; i++) {
            var send_email = "";
            var isExcluida = data[i].status == 0;

            if (data[i].send_email_at) {
              send_email = ' <i class="fa fa-envelope" title="Último envio de email desse ASO foi em: ' + this.toDate(data[i].send_email_at) + '"/>';
            }

            var item = {
              data: this.toDate(data[i].dt_cad, true),
              consulta: data[i].id_con + (data[i].rapido == "1" ? ' <img src="' + this.env.url_cs + "app/1.img/img_sof/ar.png" + '" title="Consulta gerada pelo ASO Rápido"/>' : "") + send_email,
              credenciada: data[i].credenciada ? data[i].credenciada.nome : "---",
              empresa: data[i].empresa ? data[i].empresa.nome : null,
              funcionario: data[i].funcionario ? data[i].funcionario.nome : null,
              TIPO: data[i].tipo_aso ? data[i].tipo_aso.descricao : null,
              status: data[i].tipo_status ? data[i].tipo_status.descricao : null,
              _data: data[i],
              options: {
                disable_edit: !this.validarPermissao(553),
                style: 'color:' + (data[i].status == 0 ? 'red !important' : '')
              },
              buttons: [],
            };

            if (data[i].cliente_id == 1001 || data[i].cliente_id == 1914) {
              if (data[i].pgr_docs_aso) {
                item.buttons.push({
                  icon: "fa-solid fa-file-signature fs16",
                  color: isExcluida ? "danger" : "cyan",
                  title: isExcluida ? "Consulta excluída" : "Documento assinado digitalmente",
                  click: isExcluida ? null : this.onAssinadoDigitalmente,
                  disabled: isExcluida,
                });
              } else {
                item.buttons.push({
                  icon: "fa-solid fa-file-signature fs16",
                  color: isExcluida ? "danger" : "info",
                  title: isExcluida ? "Consulta excluída" : "ASO ainda não assinado, click para enviar um lembrete de assinatura ao funcionario.",
                  click: isExcluida ? null : this.onLembreteAssinatura,
                  disabled: isExcluida,
                });
              }
            }

            if (isExcluida) {
              item.buttons.push({
                icon: "fa fa-lock",
                color: "danger",
                title: "Consulta excluída - não é possível liberar",
                disabled: true,
              });
            } else if (!data[i].id_cre && data[i].tipo_status && data[i].tipo_status.id == 66) {
              item.buttons.push({
                icon: "fa fa-unlock",
                color: "warning",
                title: "ASO Liberado. Clique para ver mais detalhes",
                click: this.onLiberarASO,
              });
            } else {
              if (!data[i].id_cre) {
                var assinado = !!data[i].pgr_docs_aso;
                var temUpload = !!data[i].arquivo_aso;
                var empresaConfigurada = data[i].empresa && data[i].empresa.aso_sign == 1 && data[i].empresa.aso_assinatura == 1;
                var podeLiberar = assinado && (temUpload || empresaConfigurada);

                if (podeLiberar) {
                  item.buttons.push({
                    icon: "fa fa-lock",
                    color: "warning",
                    title: "Liberar esse ASO",
                    click: this.onLiberarASO,
                  });
                } else {
                  var motivos = [];
                  if (!assinado) motivos.push("o funcionário ainda não assinou o ASO");
                  if (!temUpload && !empresaConfigurada) motivos.push("é necessário upload prévio do ASO ou habilitar 'Assinar ASO com Certificado' e 'Incluir Assinatura no ASO' na empresa");

                  item.buttons.push({
                    icon: "fa fa-lock",
                    color: "default",
                    title: "Não é possível liberar: " + motivos.join("; "),
                    disabled: true,
                  });
                }
              }
            }

            if (this.validarPermissao(561)) {
              item.buttons.push({
                icon: data[i].send_email_at ? "fa-solid fa-envelope-circle-check" : "fa-solid fa-paper-plane",
                color: isExcluida ? "danger" : (data[i].send_email_at ? "success" : "warning"),
                title: isExcluida ? "Consulta excluída - não é possível enviar email" : (data[i].send_email_at ? "ASO enviado por email" : "Enviar ASO por email"),
                click: isExcluida ? null : this.onDownloadASO,
                disabled: isExcluida,
              });
            }

            tableData.push(item);
          }

          this.pagination = pagination;
          this.tableData = tableData;
        }
      });
    },

    generateMD5() {
      const hash = crypto.createHash('md5').update(this.inputValue.toString()).digest('hex');
      this.md5Hash = hash;
    },
    onAssinadoDigitalmente(data) {
      const asoNumber = data.id_con.toString();
      const md5Hash = crypto.createHash('md5').update(asoNumber).digest('hex');
      const token = getCookieValue('web');
      if (token) {
        const url = `../commtrol/api/empresa/consulta/aso/${md5Hash}?token=${token}&btASO=pdf`;
        window.open(url, '_blank');
      } else {
        console.error('Token not found in cookies');
      }
    },

    onLembreteAssinatura: function (data) {
      this.consulta = data;
      this.showLembreteAssinatura = !this.showLembreteAssinatura;
    },

    onFuncionarioCadastrado: function (data) {
      // Lógica para o botão de funcionário cadastrado
      console.log("Funcionário cadastrado no sistema ASO", data);
    },
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?f6d1d69e